import { defineMessage } from 'services/localization';

export const messages = {
    defaultSection: defineMessage('email_to_supplier'),
    defaultTitle: defineMessage('email_to_supplier_section'),
    defaultDescription: defineMessage('select_how_the_email_to__will_behave_by_default'),
    defaultTemplateDescription: defineMessage('specify_the_default_sub_e_email_to_the_supplier'),
    qBooksPoSection: defineMessage('email_to_the_vendor_settings'),
    qBooksPoTitle: defineMessage('email_to_vendor_section'),
    qBooksPoDescription: defineMessage('select_how_the_email_to__will_behave_by_default_1'),
    qBooksPoTemplateDescription: defineMessage('specify_the_default_sub_the_email_to_the_vendor'),
    qBooksSalesInvoiceSection: defineMessage('email_to_the_customer_settings'),
    qBooksSalesInvoiceTitle: defineMessage('email_to_customer_section'),
    qBooksSalesInvoiceDescription: defineMessage('select_how_the_email_to__will_behave_by_default_2'),
    qBooksSalesInvoiceTemplateDescription: defineMessage('specify_the_default_sub_e_email_to_the_customer'),
    xeroQuoteSection: defineMessage('email_to_customer'),
    xeroQuoteTitle: defineMessage('email_to_customer_section_1'),
    xeroQuoteDescription: defineMessage('select_how_the_email_to__will_behave_by_default_3'),
    xeroQuoteTemplateDescription: defineMessage('specify_the_default_sub_e_email_to_the_customer'),
    xeroSalesInvoiceSection: defineMessage('email_to_customer'),
    xeroSalesInvoiceTitle: defineMessage('email_to_customer_section_1'),
    xeroSalesInvoiceDescription: defineMessage('select_how_the_email_to__will_behave_by_default_3'),
    xeroSalesInvoiceTemplateDescription: defineMessage('specify_the_default_sub_e_email_to_the_customer'),
    defaultCCTitle: defineMessage('default_cc_email_address'),
    defaultCCDescription: defineMessage('enter_the_email_address_ation_to_be_added_as_cc'),
    emailAddressesForCCOptionTitle: defineMessage('email_addresses_for_cc_option'),
    emailAddressesForCCOptionPlaceholder: defineMessage('enter_email_1'),
    emailAddressesForCCOptionEmptyListPlaceholder: defineMessage('type_in_a_valid_email_address_and_press_enter'),
    templateTitle: defineMessage('email_template'),
    templateInstruction: defineMessage('you_can_use_the_followi_ion_in_subject_and_body'),
    templateLegendCopy: defineMessage('copy_1'),
    templateSubject: defineMessage('subject'),
    templateSubjectPlaceholder: defineMessage('enter_a_default_email_subject'),
    templateBody: defineMessage('body'),
    templateBodyPlaceholder: defineMessage('enter_a_default_email_body'),
    companyNameLegendItemDescription: defineMessage('organisation_name_1'),
    contactPersonNameLegendItemDescription: defineMessage('contact_person_name'),
    poNumberLegendItemDescription: defineMessage('purchase_order_number_1'),
    poTotalAmountLegendItemDescription: defineMessage('total_amount_of_the_purchase_order'),
    quoteTotalAmountLegendItemDescription: defineMessage('total_amount_of_the_quote'),
    quoteNumberLegendItemDescription: defineMessage('quote_number'),
    quoteTermsLegendItemDescription: defineMessage('terms_of_quote'),
    quoteDecisionMakingWebPageLinkLegendItemDescription: defineMessage('link_to_quote_on_the_customer_decision_page'),
    salesInvoiceNumberLegendItemDescription: defineMessage('sales_invoice_number'),
    salesInvoiceTotalAmountLegendItemDescription: defineMessage('total_amount_of_sales_invoice'),
    supplierNameLegendItemDescription: defineMessage('supplier_name'),
    vendorNameLegendItemDescription: defineMessage('vendor_name_1'),
    customerNameLegendItemDescription: defineMessage('customer_name'),
    clientNameLegendItemDescription: defineMessage('client_name'),
    copiedToClipboard: defineMessage('copied_to_clipboard'),
    copy: defineMessage('copy'),
    qboEmailToVendorEmailCcLimitExceeded: defineMessage('please_note_that_maximu_quickbooks_online_limit'),
    enabled: defineMessage('enabled'),
    disabled: defineMessage('disabled'),
    enabledAndChecked: defineMessage('enabled_and_checked'),
    sectionNote: defineMessage('this_feature_is_restricted_during_trial'),
};
